import { makeStyles, Theme, createStyles } from "@material-ui/core";
import colors from "../../common/styles/colors";
import palette from "../../common/styles/palette";

export const useDebriefingStyles = makeStyles((theme: Theme) =>
  createStyles({
    containerPage: {
      overflowX: "hidden",
    },
    container: {
      marginLeft: "100px",
      position: "relative",
      marginTop: 50,
      width: "92%",
    },
    boxDebriefing: {
      backgroundColor: colors.white,
      border: "1px solid " + colors.grayDLight,
      borderRadius: palette.radius,
      boxShadow: palette.shadowSm,
      height: "calc(60vh + 84px)",
      maxHeight: "calc(60vh + 84px)",
      padding: 24,
      overflowY: "auto",
    },
    titleChecklist: {
      color: colors.blackMedium,
      fontSize: "1.25rem !important",
    },
    titleNumberskill: {
      color: colors.purplePrimary,
      fontSize: "1rem !important",
    },
    titleskill: {
      color: colors.purpleMediumSub,
      fontSize: "1rem !important",
    },
    titleBoxChecklist: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
    },
    boxskill: {
      paddingTop: "20px",
    },
    divider: {
      backgroundColor: colors.lilacMediumLight,
      width: "100% !important",
      marginTop: "25px !important",
      marginBottom: "25px !important",
    },
    videoBar: {
      width: "100% !important",
      backgroundColor: colors.blackDark,
      padding: "12px 16px",
    },
    boxMarker: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      minHeight: "120px",
    },
    boxMarkerTime: {
      display: "flex",
      justifyContent: "left",
      width: "100%",
      flexWrap: "wrap",
    },
    boxTime: {
      borderRadius: "6px",
      textAlign: "center",
      marginRight: "20px",
      marginTop: "14px",
      backgroundColor: colors.white,
      cursor: "pointer",
    },
    titleCameraVideo: {
      fontSize: "1.0625rem !important",
      color: colors.lilacLight,
    },
    cameraIconVideo: {
      color: colors.lilacLight,
    },
    boxTitleVideo: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
    },
    btnNewMark: {
      backgroundColor: colors.pink,
    },
    boxNewMark: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    boxNewMarkRight: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "right",
    },
    boxNewMarkButton: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "left",
    },
    textInfoNewMark: {
      color: colors.purpleLightMark,
      fontSize: "12px !important",
    },
    buttonFilter: {
      width: 35,
      height: 35,
      borderRadius: 3,
      padding: "0px !important",
      backgroundColor: colors.grayButtonCam2,
      border: "1px solid " + colors.purpleButtonCam,
      color: colors.lilacMediumLight,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
    },

    menuFilter: {
      color: colors.white,
    },
  })
);
